import React from 'react';
import {
  CheckmarkFilled20,
  InProgress20,
  Archive20,
  CloseFilled20,
  CircleDash20,
  Error20,
  ViewOffFilled20,
  Hourglass16,
  CheckmarkOutline16,
  Folder16,
  CloseOutline16
} from '@carbon/icons-react';

const StatusIcon: React.FC<Props> = ({
  status,
  isIgnore = false,
  archivedAt
}) => {
  if (isIgnore) {
    return <ViewOffFilled20 />;
  }

  if (archivedAt) {
    return <Archive20 />;
  }

  const { REACT_APP_SENTINEL_RESPONSE_COLLATION } = process.env;

  switch (status) {
    case 'created':
      return <CircleDash20 />;
    case 'waiting':
      return REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' ? (
        <Hourglass16 />
      ) : (
        <InProgress20 />
      );
    case 'fulfilled':
      return REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' ? (
        <CheckmarkOutline16 />
      ) : (
        <CheckmarkFilled20 />
      );
    case 'expired':
      return REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' ? (
        <CloseOutline16 />
      ) : (
        <Error20 />
      );
    case 'failed':
      return <CloseFilled20 />;
    case 'archived':
      return REACT_APP_SENTINEL_RESPONSE_COLLATION === 'true' ? (
        <Folder16 />
      ) : (
        <Archive20 />
      );
    default:
      return <CheckmarkFilled20 />;
  }
};

type Props = {
  status: string;
  isIgnore?: boolean;
  archivedAt?: string;
};

export default React.memo(StatusIcon);
